import React from 'react';
import { Table } from 'antd';
import { InspectionSubPOItem } from 'app/modules/inspection/types';
import { ColDefs } from './config';
import classes from './SubPO.module.scss';

type SubPOItemsDescriptionsTableProps = {
  dataSource: InspectionSubPOItem[];
};

const SubPOItemsDescriptionsTable = (
  props: SubPOItemsDescriptionsTableProps
) => {
  const { dataSource } = props;
  return (
    <Table
      className={classes.table}
      pagination={false}
      dataSource={dataSource}
      columns={ColDefs}
    ></Table>
  );
};

export default SubPOItemsDescriptionsTable;
